/**
 * Determines if a participant is anonymous.
 *
 * @param {object} participant - The participant object to check.
 * @return {boolean} Returns true if the participant is anonymous, false otherwise.
 */

export function isAnonymous(participant) {
    return !participant || participant.id === 0;
}
